import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button, DatePicker, Row, Col, Select } from 'antd';
import { BILL_STATUS } from '../billConst';
import './index.less';

const { RangePicker } = DatePicker;
const { Option } = Select;
const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 17,
  },
};
export const ProviderForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };
  const onReset = () => {
    form.resetFields();
    form.setFieldValue('order_no', '');
  };
  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='bill-form'>
      <Form form={form} name="provider"  {...layout} onFinish={onFinish} initialValues={{ ...props.defaultValue }}>
        <Row>
          <Col span={8}>
            <Form.Item name="dateRange" label='创建时间：' className='bill-form-label'>
              <RangePicker format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="supplier_name" label='供应商：' className='bill-form-label'>
              <Input placeholder="请输入供应商" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="reconciliation_no" label='对账单编号：' className='bill-form-label' >
              <Input placeholder="请输入对账单编号" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="status" label='对账单状态：' className='bill-form-label'>
              <Select placeholder="请输入对账单状态">
                {Reflect.ownKeys(BILL_STATUS).map(item => { return <Option key={item} value={item}>{BILL_STATUS[item]}</Option>; })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="order_no" label='订单号：' className='bill-form-label'>
              <Input placeholder="请输入订单号" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <div className='bill-form-btn-container'>
              <Form.Item>
                <Button className='bill-form-btn' type='primary' htmlType="submit"> 查询 </Button>
              </Form.Item>
              <Form.Item>
                <Button className='bill-form-btn' onClick={onReset}> 重置 </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
});